import { z } from 'zod'

export const CitySchema = z.object({
  cashEnabled: z.boolean(),
  code: z.string(),
  contentLanguageCode: z.string(),
  countryCode: z.string(),
  currency: z.string(),
  currencyPattern: z.string(),
  customAddressConfig: z.nullable(z.any()),
  decimalSeparator: z.nullable(z.string()),
  displayName: z.string(),
  enabled: z.boolean(),
  extraCurrencyToDisplay: z.nullable(z.string()),
  geolocation: z.object({
    polygons: z.array(z.any()),
    searchZone: z.any(),
  }),
  groupingSeparator: z.nullable(z.string()),
  languageCode: z.string(),
  name: z.string(),
  servicePhoneNumber: z.string().nullable(),
  supportedLanguages: z.array(z.string()),

  translations: z.any(),
})

export type CityType = z.infer<typeof CitySchema>
